import React from 'react';

// Components
import TableCell from '@material-ui/core/TableCell';
import AccountCodeMaskedInput from 'common/components/AccountCodeMaskedInput';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  maskInput: {
    margin: 0,
    width: '100%',
    height: '40px',
    padding: '10px',
    lineHeight: '14px',
  },
}));

const AccountCodeTableCell = props => {
  const textInputClasses = useStyles();
  const {
    id,
    code,
    lineItemKey,
    mask,
    value,
    onChange,
    classes = {},
    canEditAccountCodes,
  } = props || {};

  const isDetailSub = code === 'detail/sub';

  return (
    <TableCell key={id} className={classes.root}>
      {isDetailSub ? (
        <AccountCodeMaskedInput
          id={id}
          value={value}
          code={code}
          lineItemKey={lineItemKey}
          accountMask={mask}
          onChange={onChange}
          canEditAccountCodes={canEditAccountCodes}
          hasContainerClass={false}
          customMaskInputClass
          isLabelVisible={false}
        />
      ) : (
        <input
          value={value}
          disabled={!canEditAccountCodes}
          className={textInputClasses.maskInput}
          onChange={onChange}
          data-test-id={`AccountCodeTableCell-input-${id}/${lineItemKey}`}
        />
      )}
    </TableCell>
  );
};

export default AccountCodeTableCell;
